//
//
//
//
//
//
//
//

import Instafeed from 'instafeed.js';
import Slick from 'vue-slick';
import axios from 'axios';

export default {
  data: function () {
    return {
      images: [],
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  mounted: function () {
    axios
      .get('/wp-json/costimise/instagram-access-token')
      .then((response) => response.data)
      .then((data) => {
        const feed = new Instafeed({
          accessToken: data.access_token,
          target: 'instafeed',
          success: (response) => {
            console.log(response);

            console.log('HERE', this);

            this.images = response.data.map(({ media_url }) => media_url);

            const currIndex = this.$refs.slick.currentSlide();
            this.$refs.slick.destroy();
            this.$nextTick(() => {
              this.$refs.slick.create();
              this.$refs.slick.goTo(currIndex, true);
            });
          }
        });

        feed.run();
      });
  },
  components: {
    Slick
  }
};



// WEBPACK FOOTER //
// ./scripts/vue/instagram-carousel/InstagramCarousel.vue